import * as React from 'react';
import { MediaQuery } from '@grandvisionhq/common';
import DesktopConfigurationSummaryContainer from '../DesktopConfigurationSummary/DesktopConfigurationSummaryContainer.js';

const DesktopStepLayout = ({ children  })=>{
    const isDesktop = MediaQuery.useIsDesktop();
    return /*#__PURE__*/ React.createElement("div", {
        className: "desktop-step-layout"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "desktop-step-layout__left"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "desktop-step-layout__content"
    }, children)), isDesktop && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "desktop-step-layout__divider"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "desktop-step-layout__right"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "desktop-step-layout__content"
    }, /*#__PURE__*/ React.createElement(DesktopConfigurationSummaryContainer, null)))));
};

export { DesktopStepLayout as default };
//# sourceMappingURL=DesktopStepLayout.js.map
